defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/ActivePlayForGameOverlay',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'Shared/Framework/Ensighten/Scripts/Ensighten',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/PlaysCardsSlider'
  ],
  function (m, Ensighten, CtaButton, PlaysCardsSlider) {

    // Context:
    var ActivePlayForGameOverlay = {
      controller: function ({ controller }) {
        Object.assign(this, controller);
        this.existingActivePlaysDictionary = this.rootDictionary.get.bind({ prefix: 'ChooseGameType/ActivePlayForGameOverlay/' });
      },

      view: function (controller, { template }) {
        const body = [
          m('.play-together-existing-active-plays-overlay', [
            m('.play-together-existing-active-plays-overlay__description', controller.existingActivePlaysDictionary('Text')),
            m(PlaysCardsSlider, { controller, renderDelay: 500 })
          ])
        ];
        const footer = [
          CtaButton({
            text: controller.existingActivePlaysDictionary('CreateNewGameButton'),
            disableTracking: true,
            onClick: () => {
              Ensighten.pushGaEventOnPageRedirect('spil_sammen', 'start_nyt_spil', controller.gameType);
              window.location = controller.createNewGameLink;
            }
          })
        ];
        return template({
          heading: controller.existingActivePlaysDictionary('Title'),
          body: body,
          footer: footer
        });
      }
    };

    // Public functions:
    return ActivePlayForGameOverlay;

  });
